module.exports = __webpack_public_path__ + "CSharpPostit.svg?b2e60cb7343ce5f61dbcb65d0b8affa4";